// extracted by mini-css-extract-plugin
export var borderRadius = "_ch-4";
export var large = "_ch-3";
export var logoContainer = "_ch-0";
export var nameLogo = "_ch-2";
export var small = "_ch-1";